import React from "react";

const DeveloperMe = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800&display=swap');

        .dv-wrap {
          font-family: 'Sora', 'Segoe UI', sans-serif;
          background: #f8fafc;
          padding: 70px 16px;
          display: flex;
          justify-content: center;
        }

        .dv-wrap * {
          box-sizing: border-box;
        }

        .dv-card {
          width: 100%;
          max-width: 920px;
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 22px;
          padding: 34px;
          display: grid;
          grid-template-columns: 260px 1fr;
          gap: 34px;
          align-items: center;
          box-shadow: 0 14px 40px rgba(15, 23, 42, 0.08);
        }

        .dv-photo {
          width: 240px;
          height: 240px;
          border-radius: 20px;
          object-fit: cover;
          border: 4px solid #ecfdf3;
          box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
        }

        .dv-badge {
          display: inline-block;
          background: #ecfdf3;
          color: #16834c;
          padding: 7px 13px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 14px;
        }

        .dv-name {
          margin: 0 0 6px;
          font-size: 30px;
          line-height: 1.2;
          color: #0f172a;
          font-weight: 800;
          letter-spacing: -0.8px;
        }

        .dv-role {
          margin: 0 0 16px;
          color: #1d9e5c;
          font-size: 15px;
          font-weight: 700;
        }

        .dv-desc {
          margin: 0 0 22px;
          color: #64748b;
          font-size: 14.5px;
          line-height: 1.8;
          max-width: 600px;
        }

        .dv-info {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 24px;
        }

        .dv-chip {
          background: #f1f5f9;
          color: #334155;
          border: 1px solid #e2e8f0;
          padding: 7px 12px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 700;
        }

        .dv-contact {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 14px;
        }

        .dv-email {
          color: #334155;
          font-size: 13.5px;
          font-weight: 600;
          text-decoration: none;
        }

        .dv-email:hover {
          color: #1d9e5c;
        }

        .dv-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 12px 22px;
          background: #1d9e5c;
          color: #ffffff;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 700;
          text-decoration: none;
          transition: 0.2s ease;
        }

        .dv-btn:hover {
          background: #16834c;
          color: #ffffff;
          transform: translateY(-2px);
        }

        @media (max-width: 768px) {
          .dv-card {
            grid-template-columns: 1fr;
            text-align: center;
            padding: 28px 22px;
          }

          .dv-photo {
            margin: 0 auto;
            width: 190px;
            height: 190px;
          }

          .dv-desc {
            margin-left: auto;
            margin-right: auto;
          }

          .dv-info,
          .dv-contact {
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .dv-wrap {
            padding: 45px 14px;
          }

          .dv-name {
            font-size: 25px;
          }

          .dv-contact {
            flex-direction: column;
          }

          .dv-btn {
            width: 100%;
          }
        }
      `}</style>

      <section className="dv-wrap">
        <div className="dv-card">
          <div className="dv-image">
            <img
              src="/assets/images/developer/developer.jpeg"
              alt="Shafayet Ullah Ramim"
              className="dv-photo"
            />
          </div>

          <div className="dv-content">
            <span className="dv-badge">Developer Profile</span>

            <h1 className="dv-name">Shafayet Ullah Ramim</h1>

            <p className="dv-role">
              Full-Stack Developer & Competitive Programmer
            </p>

            <p className="dv-desc">
              A passionate CSE graduate focused on building modern, responsive,
              and user-friendly web applications. Experienced with React,
              Laravel, MySQL, authentication systems, dashboards, and e-commerce
              platforms.
            </p>

            <div className="dv-info">
              {["React.js", "Laravel", "MySQL", "JavaScript", "C++"].map(
                (item) => (
                  <span className="dv-chip" key={item}>
                    {item}
                  </span>
                )
              )}
            </div>

            <div className="dv-contact">
              <a
                href="mailto:shafayetullah200119@gmail.com"
                className="dv-email"
              >
                shafayetullah200119@gmail.com
              </a>

              <a
                href="https://ramimdev.netlify.app/"
                target="_blank"
                rel="noreferrer"
                className="dv-btn"
              >
                View Portfolio
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeveloperMe;